<template>
  <EventPopupModal @close="onClose">
    <template #body>
      <div class="event-popup-finished">
        <div class="event-popup-finished__heading">全てのPickUpイベントを確認しました。</div>
        <div class="event-popup-finished__buttons">
          <OCButton label="イベントをもっと見る" type="outline-primary" url="/events" />
          <div class="event-popup-finished__close">
            <a @click.prevent="onClose">戻る</a>
          </div>
        </div>
      </div>
    </template>
  </EventPopupModal>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api';
import OCButton from 'components/popup/OCButton.vue';
import EventPopupModal from './EventPopupModal.vue';

export default defineComponent({
  name: 'EventPopupFinishedModal',
  components: {
    EventPopupModal,
    OCButton,
  },
  emits: {
    close: () => true,
  },
  setup(_props, { emit }) {
    const onClose = () => {
      emit('close');
    };
    return {
      onClose,
    };
  },
});
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';
@import 'stylesheets/variables';

.event-popup-finished {
  padding: 64px 40px 54px;

  @media screen and (max-width: 768px) {
    padding: 48px 16px 40px;
  }
}

.event-popup-finished__heading {
  font-weight: 600;
  font-size: 34px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: $oc-black;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
}

.event-popup-finished__buttons {
  margin-top: 32px;
}

.event-popup-finished__close {
  margin-top: 12px;
  text-align: center;
  a {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: $oc-gray80;
    cursor: pointer;

    &:disabled,
    &:disabled:hover {
      color: $oc-gray10;
    }
  }
}
</style>
